import { updateField } from 'vuex-map-fields'
import Vue from 'vue'

const SET_REBUTTALS = (state, payload) => {
  state.rebuttals = payload || [{ rebuttalComments: [] }]
}

const REPLACE_REBUTTAL = (state, payload) => {
  let index = state.rebuttals.length - 1
  Vue.set(state.rebuttals, index, payload)
}

const PUSH_REBUTTAL = (state, payload) => {
  state.rebuttals.push(payload)
}

const SET_COMMENT = (state, payload) => {
  const index = state.rebuttal.rebuttalComments.findIndex(x => x.commentId === payload.commentId)
  Vue.set(state.rebuttal.rebuttalComments, index, payload)
}

const ADD_COMMENT = (state, comment) => {
  if (state.rebuttal && state.rebuttal.rebuttalComments) {
    state.rebuttal.rebuttalComments.push(comment)
  }
}

const SET_REBUTTAL = (state, payload) => {
  const index = state.rebuttals.findIndex(x => x.rebuttalId === payload.rebuttalId)
  // state.rebuttals[index] = payload
  // console.log(state.rebuttals)
  // state.rebuttals.splice(index, 1, payload)
  Vue.set(state.rebuttals, index, payload)
}

export default {
  SET_REBUTTALS,
  REPLACE_REBUTTAL,
  ADD_COMMENT,
  SET_COMMENT,
  PUSH_REBUTTAL,
  updateField,
  SET_REBUTTAL
}
